export default () => {
  return {
    content: {
      offset: 0,
      units: `minutes`,
    },
  };
};
